import { get, post, put, deleted } from '../utils/http';

export function getSurveyFormDataByCode(param, merchant_code, service_code) {
    // return get(`survey/survey/code/${param.code}`, null, merchant_code, service_code);
    return get(`${merchant_code && !service_code ? merchant_code : ''}survey/survey/code/${param.code}`, null, merchant_code, service_code);
};

export function saveSurveyData(param, merchant_code, service_code) {
    // return post(`survey/result/save`, param, merchant_code, service_code);
    return post(`${merchant_code && !service_code ? merchant_code : ''}survey/result/save`, param, merchant_code, service_code);
};

export function getCustomFormData(param, merchant_code, service_code) {
    return post(`${merchant_code && !service_code ? merchant_code : ''}form/V2/schema`, param, merchant_code, service_code);
};

export function submitCustomForm(param, merchant_code, service_code) {
    return post(`${merchant_code && !service_code ? merchant_code : ''}form/submit`, param, merchant_code, service_code);
};

//新的form提交接口  form type === booking/general时
export function submitCustomFormNew(param, merchant_code, service_code) {
    return post(`${merchant_code && !service_code ? merchant_code : ''}form/submit/${param.formCode}`, param, merchant_code, service_code);
};

//具体字段获取渲染的数据
export function getFieldOptionsByCode(param, merchant_code, service_code) {
    return post(`${merchant_code && !service_code ? merchant_code : ''}form/field-options/${param.formCode}`, param, merchant_code, service_code);
};

export function getGroupFormByGroup(group, merchant_code, service_code) {
    return get(`${merchant_code && !service_code ? merchant_code : ''}form/group-form/${group}`, null, merchant_code, service_code);
};

//动态获取渲染的数据
export function getDynamicFieldByCode(param, merchant_code, service_code) {
    return post(`${merchant_code && !service_code ? merchant_code : ''}form/field-dynamic/${param.formCode}`, param, merchant_code, service_code);
};
